<template>
  <div class="container">
  <ol class="breadcrumb">
    <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
    <li><router-link :to="{ name: 'adminUsers' }">Admin - Users</router-link></li>
    <li class="active">{{ user.first_name }} {{ user.last_name }}</li>
  </ol>

  <!-- <p>uid {{ userId }}</p> -->
  <div class="row">
    <div class="col-xs-12 col-sm-10">
      <form class="form-horizontal">
        <div class="form-group">
          <label for="inputFirstName" class="col-sm-3 control-label">First Name</label>
          <div class="col-sm-7">
            <input v-model="user.first_name" type="text" class="form-control" id="inputFirstName">
          </div>
        </div>
        <div class="form-group">
          <label for="inputLastName" class="col-sm-3 control-label">Last Name</label>
          <div class="col-sm-7">
            <input v-model="user.last_name" type="text" class="form-control" id="inputLastName">
          </div>
        </div>
        <div class="form-group">
          <label for="inputEmail" class="col-sm-3 control-label">Email</label>
          <div class="col-sm-7">
            <input v-model="user.email" type="text" class="form-control" id="inputEmail">
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-2">
            <button @click.prevent="save" type="submit" class="btn btn-primary">Save</button>
          </div>
          <div class="col-sm-5">
            <p v-if="saved">User saved successfully.</p>
            <p v-if="savedError" class="error">There was a problem saving the user.</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<style scoped>
p.error {
  color: red;
}
</style>

<script>
export default {
  data () {
    return {
      user: {
        id: 0,
        password: Math.random().toString(36).slice(2),
        first_name: '',
        last_name: '',
        email: ''
      },
      saved: false,
      savedError: false
    }
  },

  computed: {
    userId () {
      return this.$route.params.id
    }
  },

  methods: {
    showSavedMessage () {
      this.saved = true
      setTimeout(() => {
        this.saved = false
      }, 3000)
    },
    save () {
      var promise
      this.saved = false
      this.savedError = false

      if (this.user.id === 0) {
        promise = this.$apiAdmin.createUser(this.user)
      } else {
        promise = this.$apiAdmin.updateUser(this.user.id, this.user)
      }

      promise
      .then((user) => {
        // console.log('user updated', user)
        this.user = user
        this.showSavedMessage()

        // if creating, redirect to new url
        if (this.userId === 0) {
          this.$router.replace(this.$route.path.replace('0', user.id))
        }
      })
      .catch((error) => {
        this.savedError = true
        console.log('user update error', error)
      })
    },
    fetch () {
      if (this.userId === 0) {
        return
      }

      this.$apiAdmin.fetchUser(this.userId)
      .then((user) => {
        this.user = user
      })
      .catch((error) => {
        console.log('admin user fetch error', error)
      })
    }
  },

  mounted () {
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// AdminUser.vue?e5dd6334